import Demographics from './Demographics';

export default Demographics;
